import { Link } from 'react-router-dom'
import Logo from '../components/Logo'
import AuthHeader from '../components/AuthHeader'

const GITHUB_REPO = 'https://github.com/yezhuoyang/QCloud'

type UpdateType = 'feature' | 'fix' | 'refactor' | 'test'

interface UpdateEntry {
  date: string
  message: string
  hash: string
}

function classifyCommit(msg: string): UpdateType {
  const lower = msg.toLowerCase()
  if (lower.startsWith('fix')) return 'fix'
  if (lower.startsWith('add')) return 'feature'
  if (lower.includes('test')) return 'test'
  return 'refactor'
}

const updates: UpdateEntry[] = [
  { date: '2026-03-22', message: 'Add affiliation field to user registration, shown on leaderboards', hash: '5708b09' },
  { date: '2026-03-22', message: 'Add Quantum Hype Index: real-time weighted stock index of quantum companies (IONQ, IBM, RGTI, QBTS, GOOG, MSFT, AMZN, QUBT)', hash: 'bb74202' },
  { date: '2026-03-22', message: 'Add Publications section on landing page with recommended papers', hash: '192fd63' },
  { date: '2026-03-22', message: 'Add floating table of contents for landing page navigation', hash: '2b703f3' },
  { date: '2026-03-22', message: 'Add "How far are we from useful quantum applications?" hero callout', hash: 'c472f2a' },
  { date: '2026-03-22', message: 'Add Quantum Hype Debate section with 3 YouTube videos', hash: '2b9b326' },
  { date: '2026-03-22', message: 'Add Featured Talks by Organizers: POPL\'25 Quantum 3.0 + Education at Scale', hash: '0cf67a0' },
  { date: '2026-03-22', message: 'Add collaboration logos: UCLA (academic), IBM (industry), Qrisp (software)', hash: 'f126706' },
  { date: '2026-03-22', message: 'Add workflow diagram with 3 hardware types: Superconducting, Ion Trap, Neutral Atom', hash: 'fb04cb5' },
  { date: '2026-03-22', message: 'Redesign workflow diagram: 2 converging inputs (QEC + Circuits), 3 fanning hardware outputs', hash: '2455c16' },
  { date: '2026-03-22', message: 'Add 4-panel leaderboard layout: Programmer + AI Agent (left), Hardware + Language (right)', hash: '6e1e3d4' },
  { date: '2026-03-22', message: 'Fix leaderboard: single unified ranking with competition points (3/2/1 per challenge)', hash: '55aac8d' },
  { date: '2026-03-22', message: 'Simplify landing page: remove QEC Tools, Tools & Resources sections', hash: '1e5d83f' },
  { date: '2026-03-22', message: 'Enable Qrisp for all challenges including oracle-based intermediate (via from_qiskit interop)', hash: 'aaf639f' },
  { date: '2026-03-22', message: 'Fix all challenge tests: inverse circuits for Bell/GHZ, oracle injection for DJ/BV/Grover/QPE', hash: 'f8d4c83' },
  { date: '2026-03-22', message: 'Redesign intermediate challenges: oracle provided to students, clear descriptions', hash: 'be0e1da' },
  { date: '2026-03-22', message: 'Verify all 7 challenges on IBM hardware (scores 0.55-1.0)', hash: 'cf7ae6f' },
  { date: '2026-03-21', message: 'Add per-user hardware submission limit (3 per challenge with platform key)', hash: 'cca4cd9' },
  { date: '2026-03-21', message: 'Switch IBM channel to ibm_quantum_platform + QuantumArena instance', hash: '04a1dea' },
  { date: '2026-03-21', message: 'Fix challenge auto-connect for logged-in users', hash: '04a1dea' },
  { date: '2026-03-21', message: 'Add Qrisp language support with oracle interop (QuantumCircuit.from_qiskit)', hash: '' },
  { date: '2026-03-21', message: 'Add language selector dropdown and language-specific starter code', hash: '' },
  { date: '2026-03-21', message: 'Add unified test_code system: def test(student_circuit, run_sim) -> float', hash: '' },
  { date: '2026-03-21', message: 'Add 5 intermediate challenges: Deutsch-Jozsa, Bernstein-Vazirani, Grover, Modular Exp, QPE', hash: '' },
  { date: '2026-03-21', message: 'Add 3 beginner challenges: Bell State, GHZ State, 2-Bit Adder', hash: '' },
  { date: '2026-03-21', message: 'Add Challenge Arena with 3-tier track system (Beginner, Intermediate, Advanced)', hash: '' },
  { date: '2026-03-21', message: 'Add deploy-prod skill and deployment script (scripts/deploy_prod.sh)', hash: '' },
  { date: '2026-03-11', message: 'Add Topology Code editor link to Quantum Memory challenge page', hash: '' },
  { date: '2026-03-11', message: 'Add surface code SVG icon for QEC Tools on landing page', hash: '' },
  { date: '2026-03-11', message: 'Add QEC Tools section and Update Log page', hash: '' },
  { date: '2026-03-11', message: 'Add 3D torus stabilizer code editor with interactive qubit placement and drag', hash: '' },
  { date: '2026-03-10', message: 'Fix Toffoli IBM submit robustness and add stuck job recovery', hash: 'fb5a06a' },
  { date: '2026-03-09', message: 'Remove Process Fidelity display from Toffoli homework UI', hash: '3edbe29' },
  { date: '2026-03-09', message: 'Fix Hilbert-Schmidt distance formula and remove 7 CX gate requirement', hash: '4a158ed' },
  { date: '2026-03-09', message: 'Add QEC pipeline tests: surface code simulation and IBM hardware decoding', hash: 'd0363cb' },
  { date: '2026-03-09', message: 'Fix import path for get_current_user in quantum_memory API', hash: '41b899c' },
  { date: '2026-03-09', message: 'Add Quantum Memory challenge: Stim QEC simulation + IBM hardware submission', hash: '246912c' },
  { date: '2026-03-09', message: 'Fix 504 timeout and job history 500 error', hash: '7093142' },
  { date: '2026-03-09', message: 'Fix Toffoli method placeholder and layout validation edge lookup', hash: '957a1fc' },
  { date: '2026-03-09', message: 'Add Toffoli homework: 3-way submission, transpile preview, layout validation', hash: '51514ae' },
  { date: '2026-03-09', message: 'Reduce polling load: 60s intervals, semaphore limit, non-blocking queue', hash: 'a0a43c5' },
  { date: '2026-03-07', message: 'Fix job polling cascade bug: recover stuck Running/Queued jobs', hash: '4e20150' },
  { date: '2026-03-06', message: 'Move leaderboards to left/right sidebars on landing page', hash: 'c966cf6' },
  { date: '2026-03-06', message: 'Add About and People pages with admin editing', hash: '391136e' },
  { date: '2026-03-06', message: 'Add workflow diagram to landing page', hash: 'df80423' },
  { date: '2026-03-06', message: 'Rebrand QCloud to QuantumArena across all pages', hash: '6d5dc43' },
  { date: '2026-03-06', message: 'Add QuantumArena challenge system with custom evaluation', hash: '0a6195c' },
  { date: '2026-03-06', message: 'Add deploy script for server setup and restart', hash: 'b165b27' },
  { date: '2026-03-06', message: 'Add code viewing across result page, job history, and leaderboard', hash: 'a69a98f' },
  { date: '2026-03-05', message: 'Add auto-save draft and reset button to homework editor', hash: '9e4e86e' },
  { date: '2026-03-04', message: 'Add Job History page for students to view past submissions', hash: 'f705b1f' },
  { date: '2026-03-04', message: 'Fix budget system: use IBM metrics, skip for own API key', hash: '1032d6f' },
  { date: '2026-03-04', message: 'Bypass queue for submissions with custom IBM API key', hash: '627f094' },
  { date: '2026-03-04', message: 'Add async concurrency handling for simulator endpoints', hash: '5fa5960' },
  { date: '2026-03-04', message: 'Support dynamic circuits in validator, show leaderboards side by side', hash: '542a366' },
]

const typeColors: Record<UpdateType, string> = {
  feature: 'bg-green-100 text-green-700',
  fix: 'bg-red-100 text-red-700',
  refactor: 'bg-blue-100 text-blue-700',
  test: 'bg-yellow-100 text-yellow-700',
}

const typeLabels: Record<UpdateType, string> = {
  feature: 'Feature',
  fix: 'Fix',
  refactor: 'Update',
  test: 'Test',
}

function UpdateLogPage() {
  // Group updates by date
  const grouped = updates.reduce<Record<string, (UpdateEntry & { type: UpdateType })[]>>((acc, entry) => {
    if (!acc[entry.date]) acc[entry.date] = []
    acc[entry.date].push({ ...entry, type: classifyCommit(entry.message) })
    return acc
  }, {})

  const sortedDates = Object.keys(grouped).sort((a, b) => b.localeCompare(a))

  return (
    <div className="min-h-screen bg-gradient-to-br from-qcloud-light via-white to-qcloud-bg">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur border-b border-qcloud-border px-6 py-3 flex items-center justify-between sticky top-0 z-20">
        <div className="flex items-center gap-3">
          <Link to="/">
            <Logo size="small" />
          </Link>
          <Link to="/" className="text-xl font-bold bg-gradient-to-r from-qcloud-primary to-qcloud-secondary bg-clip-text text-transparent">
            QuantumArena
          </Link>
        </div>
        <div className="flex items-center gap-4">
          <Link to="/" className="text-sm text-qcloud-muted hover:text-qcloud-primary transition-colors">Home</Link>
          <Link to="/about" className="text-sm text-qcloud-muted hover:text-qcloud-primary transition-colors">About</Link>
          <AuthHeader />
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-qcloud-text mb-2">Update Log</h1>
        <p className="text-qcloud-muted mb-8">Recent changes, features, and bug fixes.</p>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-qcloud-border" />

          {sortedDates.map(date => (
            <div key={date} className="mb-8">
              {/* Date header */}
              <div className="flex items-center gap-3 mb-3 relative">
                <div className="w-8 h-8 rounded-full bg-qcloud-primary flex items-center justify-center z-10">
                  <span className="text-white text-xs font-bold">{new Date(date + 'T00:00:00').getDate()}</span>
                </div>
                <h2 className="text-lg font-semibold text-qcloud-text">{date}</h2>
              </div>

              {/* Entries for this date */}
              <div className="ml-12 space-y-2">
                {grouped[date].map((entry, i) => (
                  <div key={i} className="flex items-start gap-3 p-3 bg-white rounded-lg border border-qcloud-border hover:shadow-sm transition-shadow">
                    <span className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${typeColors[entry.type]}`}>
                      {typeLabels[entry.type]}
                    </span>
                    <span className="text-sm text-qcloud-text flex-1">{entry.message}</span>
                    {entry.hash && (
                      <a
                        href={`${GITHUB_REPO}/commit/${entry.hash}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-xs text-qcloud-muted hover:text-qcloud-primary font-mono whitespace-nowrap"
                      >
                        {entry.hash.slice(0, 7)}
                      </a>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  )
}

export default UpdateLogPage
